import { Grid, Typography } from "@mui/material";
import { DialogInfoItem } from "./DialogInfoItem";
import { MonthsAndYearValues } from "../types";

export function MonthAndYearValuesList(props: {
  title: string;
  values?: MonthsAndYearValues | null;
  itemsFontSize?: number;
}) {
  const { title, values, itemsFontSize } = props;
  return (
    <Grid item xs={12} sm={6}>
      <Typography sx={{ fontWeight: "bold", marginTop: "10px" }}>
        {title}
      </Typography>
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Janeiro"
        value={values?.jan ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Fevereiro"
        value={values?.feb ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Março"
        value={values?.mar ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Abril"
        value={values?.apr ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Maio"
        value={values?.may ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Junho"
        value={values?.jun ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Julho"
        value={values?.jul ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Agosto"
        value={values?.aug ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Setembro"
        value={values?.sep ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Outubro"
        value={values?.oct ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Novembro"
        value={values?.nov ?? "Não informado"}
      />
      <DialogInfoItem
        fontSize={itemsFontSize}
        name="Dezembro"
        value={values?.dec ?? "Não informado"}
      />
      {values?.year && (
        <DialogInfoItem
          fontSize={itemsFontSize}
          name="Ano"
          value={values?.year ?? "Não informado"}
        />
      )}
    </Grid>
  );
}
